import { Description, Field, Label, Select } from "@headlessui/react";
import { useContext } from "react";
import SubscriptionFormContext from "./SubscriptionFormContext";

interface FrequencySelectorProps {
  sellingPlanId: string;
  setSellingPlanId: (sellingPlanId: string) => void;
}

export default function FrequencySelector({
  sellingPlanId,
  setSellingPlanId,
}: FrequencySelectorProps) {
  const { frequencies } = useContext(SubscriptionFormContext);

  return (
    <Select
      name="frequency"
      value={sellingPlanId}
      onChange={(e) => setSellingPlanId(e.target.value as string)}
      aria-label="Frequency"
      className="
        xw-full
        xfont-grotesque xfont-semibold

        xtext-3xl
        md:xtext-4xl
        xbg-transparent
        xborder-4 xborder-dark-green xrounded-3xl
        xpx-8 xpy-2
      "
    >
      {frequencies.map((frequency) => (
        <option key={frequency.sellingPlanId} value={frequency.sellingPlanId}>
          {frequency.label}
        </option>
      ))}
    </Select>
  );
}
